<template>
  <div id="pubTable">
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column prop="date" label="个人月度绩效等级">
      </el-table-column>
      <el-table-column prop="name" label="绩效等级分值规则">
      </el-table-column>
      <el-table-column prop="address" label="绩效工资发放比例">
      </el-table-column>
      <el-table-column prop="address1" label="提成发放比例">
      </el-table-column>
    </el-table>
    <el-alert style="margin-top: 30px"
      title="实际比例发放：例如绩效得分75分，对应的绩效工资发放75%" type="error" :closable="false">
    </el-alert>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableData: [
        {
          date: 'A',
          name: '90 ≤ A ≤ 100',
          address: '100%',
          address1: '100%',
        },
        {
          date: 'B',
          name: '80 ≤ B≤ 89',
          address: '90%',
          address1: '100%',
        },
        {
          date: 'C',
          name: '70 ≤ C ≤ 79',
          address: '实际比例发放',
          address1: '90%',
        },
        {
          date: 'D',
          name: '60 ≤ D ≤ 69',
          address: '实际比例发放',
          address1: '80%',
        },
        {
          date: 'E',
          name: '0 ≤ E ≤ 59',
          address: '不发放',
          address1: '50%',
        },
      ],
    }
  },
}
</script>
<style scoped>
table {
  width: 100%;
}
td {
  font-size: 14px;
  color: #919399;
}
th:first{
  color: red;
}
</style>